import { env } from '@/config/env';

/** MIME types accepted at the upload step, mapped to a human-readable label. */
export const ACCEPTED_FILE_TYPES: Record<string, string> = {
  'application/pdf': 'PDF',
  // 'application/msword': 'DOC',
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  // 'application/vnd.ms-powerpoint': 'PPT',
  // 'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
};

export const ACCEPTED_FILE_EXTENSIONS = ['.pdf', 
  //'.doc', '.docx',
  //  '.ppt', '.pptx', 
   '.jpg', '.jpeg', '.png'];

export const ACCEPTED_FORMAT_LABELS = ['PDF', 'JPG / PNG'];

export const MAX_UPLOAD_BYTES = env.maxUploadMb * 1024 * 1024;
